module.exports = __webpack_public_path__ + "media/images/faces/face15-00f72a57c8fc2dd4219b3ea3597229b3.jpg";